import { getToken } from '@optimus-web/common';
import { FilterChipProps } from './FilterChip';

type Variant = 'active' | 'inactive';
type State = 'disabled' | 'default';
type FilterChipTokenConfig = Record<Variant, Record<State, ReturnType<typeof getToken> | 'transparent'>>;
type Props = Pick<FilterChipProps, 'disabled' | 'active'>;

export const getVariantAndState = (props: Props) => {
    const variant: Variant = props?.active ? 'active' : 'inactive';
    const state: State = props?.disabled ? 'disabled' : 'default';
    return { variant, state };
};

export const getBackgroundColor = (props: Props) => {
    const backgroundColorTokens: FilterChipTokenConfig = {
        active: {
            disabled: getToken('backgroundDisabled'),
            default: getToken('backgroundInteractiveNeutralDefault'),
        },
        inactive: {
            disabled: getToken('backgroundDisabled'),
            default: 'transparent',
        },
    };

    const { variant, state } = getVariantAndState(props);
    return backgroundColorTokens[variant][state];
};

export const getHoverBackgroundColor = (props: Props) => {
    const hoverBackgroundColorTokens: FilterChipTokenConfig = {
        active: {
            disabled: getToken('backgroundDisabled'),
            default: getToken('backgroundInteractiveNeutralHover'),
        },
        inactive: {
            disabled: getToken('backgroundDisabled'),
            default: getToken('backgroundInteractiveNeutralSubtleHover'),
        },
    };

    const { variant, state } = getVariantAndState(props);
    return hoverBackgroundColorTokens[variant][state];
};

export const getActiveBackgroundColor = (props: Props) => {
    const activeBackgroundColorTokens: FilterChipTokenConfig = {
        active: {
            disabled: getToken('backgroundDisabled'),
            default: getToken('backgroundInteractiveNeutralActive'),
        },
        inactive: {
            disabled: getToken('backgroundDisabled'),
            default: getToken('backgroundInteractiveNeutralSubtleActive'),
        },
    };

    const { variant, state } = getVariantAndState(props);
    return activeBackgroundColorTokens[variant][state];
};

export const getBorderColor = (props: Props) => {
    const borderColorTokens: FilterChipTokenConfig = {
        active: {
            disabled: 'transparent',
            default: 'transparent',
        },
        inactive: {
            disabled: 'transparent',
            default: getToken('borderInteractiveSecondaryDefault'),
        },
    };

    const { variant, state } = getVariantAndState(props);
    return borderColorTokens[variant][state];
};

export const getHoverBorderColor = (props: Props) => {
    const hoverBorderColorTokens: FilterChipTokenConfig = {
        active: {
            disabled: 'transparent',
            default: 'transparent',
        },
        inactive: {
            disabled: 'transparent',
            default: getToken('borderInteractiveSecondaryHover'),
        },
    };

    const { variant, state } = getVariantAndState(props);
    return hoverBorderColorTokens[variant][state];
};

export const getActiveBorderColor = (props: Props) => {
    const activeBorderColorTokens: FilterChipTokenConfig = {
        active: {
            disabled: 'transparent',
            default: 'transparent',
        },
        inactive: {
            disabled: 'transparent',
            default: getToken('borderInteractiveSecondaryActive'),
        },
    };

    const { variant, state } = getVariantAndState(props);
    return activeBorderColorTokens[variant][state];
};

export const getColor = (props: Props) => {
    const colorTokens: FilterChipTokenConfig = {
        active: {
            disabled: getToken('textDisabled'),
            default: getToken('textStaticPrimary'),
        },
        inactive: {
            disabled: getToken('textDisabled'),
            default: getToken('textStaticPrimary'),
        },
    };

    const { variant, state } = getVariantAndState(props);
    return colorTokens[variant][state];
};

export const getHoverColor = (props: Props) => {
    const hoverColorTokens: FilterChipTokenConfig = {
        active: {
            disabled: getToken('textDisabled'),
            default: getToken('textStaticPrimary'),
        },
        inactive: {
            disabled: getToken('textDisabled'),
            default: getToken('textStaticPrimary'),
        },
    };

    const { variant, state } = getVariantAndState(props);
    return hoverColorTokens[variant][state];
};

export const getActiveColor = (props: Props) => {
    const activeColorTokens: FilterChipTokenConfig = {
        active: {
            disabled: getToken('textDisabled'),
            default: getToken('textStaticPrimary'),
        },
        inactive: {
            disabled: getToken('textDisabled'),
            default: getToken('textStaticPrimary'),
        },
    };

    const { variant, state } = getVariantAndState(props);
    return activeColorTokens[variant][state];
};
